// ADDED
import React from "react";
import { GeneralMessage } from "../../../common/APICommon";
import { LoadingSpinner } from "../../../common/Loading";
import { useLeaveIncentiveBatch } from "../../hooks/useLeaveIncentiveBatch";
import LeaveIncentiveBatchModule from "../../components/modules/LeaveIncentiveBatch/LeaveIncentiveBatchModule";

const LeaveIncentiveBatchPage = ({ user, isHideSideMenu }) => {
  // Initialize the hook with user context for audit trails
  const batchMethods = useLeaveIncentiveBatch(user);

  return (
    <>
      <div className={`MainBody row ${isHideSideMenu ? "MainBody2" : ""}`}>
        <div className="LeftSpace"></div>
        <div className={`BodySpace ${isHideSideMenu ? "BodySpace2" : ""}`}>
          <div className="MainteInfo shadow-xl bg-white rounded-lg">
            <div className="mainteHeader p-4 border-b">
              <div className='sub-title row text-sm'>
                <span className="text-gray-400">{"Payroll Module > "}</span>
                <span className="border-b border-black">{"Leave Incentive Batch"}</span>
              </div>
              <h3 className="text-xl font-bold mt-2">Leave Incentive Batch</h3>
            </div>

            {/* Pass all hook data and methods to the module orchestrator */}
            <LeaveIncentiveBatchModule
              user={user}
              {...batchMethods}
            />
          </div>
        </div>
      </div>

      {/* Global messaging for success/error alerts */}
      <GeneralMessage
        form={batchMethods.showMessage}
        message={batchMethods.message}
        isSuccess={batchMethods.isSuccess}
      />

      {/* Global loading state overlay */}
      <LoadingSpinner loading={batchMethods.loading} />
    </>
  );
};

export default LeaveIncentiveBatchPage;